export default __webpack_public_path__ + "static/media/logo_color.a069f415.svg";